/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { FC, useState } from 'react';
import { BasicInput } from '../../shared/inputs/BasicInput';
import * as yup from 'yup';
import styles from './AudiencePersonaPopup.module.css';
import { BasicButtonSelectionInput } from '../../shared/inputs/BasicButtonSelectionInput';
import {
  ageOptions,
  locationOptions,
  genderOptions,
  occupationOptions,
} from '../editorPage/forms/formInputs/DefaultOptions';
import { BoxedAutoResizeTextarea } from '../../shared/inputs/BoxedAutoResizeTextarea';
import { BasicButton } from '../../shared/buttons/BasicButton';
import { usePersonaContext } from '../../../contexts/PersonaContext';
import { OptionsOrGroups, GroupBase } from 'react-select/dist/declarations/src';
import Select from 'react-select';
import mixpanel from 'mixpanel-browser';
import { useAuthContext } from '../../../contexts/AuthContext';
import { uuid } from 'uuidv4';
import Image from 'next/image';
import Tooltip from '../../shared/tooltips/Tooltip';

type AudiencePersonaProps = {
  audience: string;
  brand: unknown;
  gender?: string[];
  age?: string[];
  occupation?: string[];
  location?: string[];
  painpoints: string;
  id: string;
  profilePic?: string;
  goals?: string;
  barriers?: string;
  triggers?: string;
  onClose: () => void;
  organizationOwner?: boolean;
  organizationPersona?: boolean;
};

export const EditAudiencePersonaPopup: FC<AudiencePersonaProps> = (
  AudienceData
) => {
  const [loading, setLoading] = useState(false);
  const [successfulAudienceSaved, setSuccessfulAudienceSaved] = useState(false);
  const [value, setValue] = useState<unknown | null>(AudienceData.brand);
  const { updateAudience } = usePersonaContext();
  const [brandError, setBrandError] = useState(false);
  const { userData } = useAuthContext();
  const [photoNumber, setPhotoNumber] = useState<string>('');

  const imagePaths = [
    '/icons/Rectangle-1.svg',
    '/icons/Rectangle-2.svg',
    '/icons/Rectangle-3.svg',
    '/icons/Rectangle-4.svg',
    '/icons/Rectangle-5.svg',
    '/icons/Rectangle-6.svg',
    '/icons/Rectangle-7.svg',
    '/icons/Rectangle-8.svg',
    '/icons/Rectangle-9.svg',
    '/icons/Rectangle-10.svg',
    '/icons/Rectangle-11.svg',
    '/icons/Rectangle-12.svg',
    '/icons/Rectangle-13.svg',
    '/icons/Rectangle-14.svg',
    '/icons/Rectangle-15.svg',
    '/icons/Rectangle-16.svg',
    '/icons/Rectangle-17.svg',
    '/icons/Rectangle-18.svg',
    '/icons/Rectangle-19.svg',
    '/icons/Rectangle-20.svg',
    '/icons/Rectangle-21.svg',
    '/icons/Rectangle-22.svg',
    '/icons/Rectangle-23.svg',
    '/icons/Rectangle-24.svg',
    '/icons/Rectangle-25.svg',
    '/icons/Rectangle-26.svg',
    '/icons/Rectangle-27.svg',
    '/icons/Rectangle-28.svg',
    '/icons/Rectangle-29.svg',
    '/icons/Rectangle-30.svg',
    '/icons/Rectangle-31.svg',
    '/icons/Rectangle-32.svg',
    '/icons/Rectangle-33.svg',
    '/icons/Rectangle-34.svg',
    '/icons/Rectangle-35.svg',
    '/icons/Rectangle-36.svg',
    '/icons/Rectangle-37.svg',
    '/icons/Rectangle-38.svg',
    '/icons/Rectangle-39.svg',
    '/icons/Rectangle-40.svg',
    '/icons/Rectangle-41.svg',
    '/icons/Rectangle-42.svg',
    '/icons/Rectangle-43.svg',
  ];

  const [selectedIcon, setSelectedIcon] = useState<string>(
    AudienceData.profilePic ?? ''
  );
  const [showIconPicker, setShowIconPicker] = useState<boolean>(false);

  const photo = '/icons/Rectangle-' + photoNumber + '.svg';

  useEffect(() => {
    const photoID = uuid();
    const FilteredID = photoID.replace(/\D/g, '');
    const slicedPhoto = FilteredID.slice(0, 1);
    setPhotoNumber(slicedPhoto);
  }, []);

  useEffect(() => {
    if (successfulAudienceSaved) {
      const resetCopyButtonTextTimeout = setTimeout(() => {
        setSuccessfulAudienceSaved(false);
      }, 5000);
      return () => clearTimeout(resetCopyButtonTextTimeout);
    }
  }, [successfulAudienceSaved]);

  useEffect(() => {
    if (value !== '') {
      setBrandError(false);
    }
  }, [value]);

  useEffect(() => {
    setShowIconPicker(false);
  }, [selectedIcon]);

  const { brandPersonas } = usePersonaContext();
  if (!brandPersonas)
    return (
      <h3>
        🤔 Your team currently has no personas. Create your first brand persona.
      </h3>
    );
  if (brandPersonas.length === 0) {
    return (
      <h3>
        🤔 Your team currently has no personas. Create your first brand persona.
      </h3>
    );
  }

  function validateSize(files: FileList | null) {
    if (files) {
      const fileRef = files[0] || '';
      const fileSize = fileRef.size; // in MiB
      if (fileSize > 780000) {
        alert('File size exceeds 780kb');
        // $(file).val(''); //for clearing with Jquery
      } else {
        // Proceed further
        convertFile(files);
      }
    }
  }

  function convertFile(files: FileList | null) {
    if (files) {
      const fileRef = files[0] || '';
      const fileType: string = fileRef.type || '';
      console.log('This file upload is of type:', fileType);
      const reader = new FileReader();
      reader.readAsBinaryString(fileRef);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reader.onload = (ev: any) => {
        // convert it to base64
        // setFileBase64(`data:${fileType};base64,${btoa(ev.target.result)}`)
        setSelectedIcon(`data:${fileType};base64,${btoa(ev.target.result)}`);
      };
    }
    // console.log(filebase64);
    // console.log(files);
  }

  // const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log('file upload')
  //     const file = event.target.files?.[0];
  //     if (file) {
  //         const reader = new FileReader();
  //         reader.onload = (e) => setSelectedIcon(e.target?.result as string);
  //         reader.readAsDataURL(file);
  //         console.log(selectedIcon)
  //     }
  // }

  function handleFileUpload(event: React.ChangeEvent<HTMLInputElement>) {
    validateSize(event.target.files);
  }

  const IconClick = (icon: string) => {
    setSelectedIcon(icon);
    // setShowIconPicker(!showIconPicker);
  };

  const optionlist: OptionsOrGroups<unknown, GroupBase<unknown>> | undefined[] =
    brandPersonas.map((brand) => {
      return {
        value: brand.id,
        label: brand.brand,
      };
    });

  const AudiencePersonaSchema = yup.object({
    audience: yup.string().required('Please enter an audience name.'),
    painpoints: yup.string().required('Please describe their pain-points.'),
    occupation: yup
      .array()
      .min(1, 'Please select their attributes.')
      .required('Please select their attributes.'),
    // gender: yup.array().min(1, 'Please select their gender.').required('Please select their gender.'),
    age: yup
      .array()
      .min(1, 'Please select their age range.')
      .required('Please select their age range.'),
    // location: yup.array().min(1, 'Please select their location.').required('Please select their location.'),
  });

  return (
    <>
      <Formik
        initialValues={{
          audience: AudienceData.audience,
          brand: AudienceData.brand,
          gender: AudienceData.gender,
          age: AudienceData.age,
          occupation: AudienceData.occupation,
          location: AudienceData.location,
          painpoints: AudienceData.painpoints,
          id: AudienceData.id,
          triggers: AudienceData.triggers,
          barriers: AudienceData.barriers,
          goals: AudienceData.goals,
          profilePic: AudienceData.profilePic,
        }}
        onSubmit={async (values) => {
          setLoading(true);
          const brandValue = value;
          const audience = values.audience;
          const brand = brandValue;
          const gender = Array.isArray(values.gender)
            ? values.gender.filter((e) => e.length)
            : undefined;
          const age = Array.isArray(values.age)
            ? values.age.filter((e) => e.length)
            : undefined;
          const occupation = Array.isArray(values.occupation)
            ? values.occupation.filter((e) => e.length)
            : undefined;
          const location = Array.isArray(values.location)
            ? values.location.filter((e) => e.length)
            : undefined;
          const painpoints = values.painpoints ? values.painpoints : '';
          const id = AudienceData.id;
          const profilePic = selectedIcon.length !== 0 ? selectedIcon : photo;
          const triggers = values.triggers ?? AudienceData.triggers;
          const barriers = values.barriers ?? AudienceData.barriers;
          const goals = values.goals ?? AudienceData.goals;

          await updateAudience({
            audience,
            brand,
            gender,
            age,
            occupation,
            location,
            painpoints,
            id,
            profilePic: profilePic,
            triggers,
            barriers,
            goals,
          });
          console.log('this is profile', profilePic);
          setLoading(false);
          setSuccessfulAudienceSaved(true);
          mixpanel.track('Audience Persona Edit Completed', {
            email: userData?.email,
            displayName: userData?.displayName,
          });
          AudienceData.onClose();
        }}
        validationSchema={AudiencePersonaSchema}
      >
        {(props) => {
          return (
            <>
              <div className={styles['form-popup']}>
                {/* header starts here */}
                <div className={styles['top-header']}>
                  <h3>Audience Persona</h3>
                  <div className={styles['flex2']}>
                    <BasicButton
                      type="button"
                      theme="white"
                      loading={loading}
                      disabled={loading}
                      text={'Cancel'}
                      onClick={() => AudienceData.onClose()}
                    />
                    {((AudienceData.organizationPersona &&
                      AudienceData.organizationOwner) ||
                      !AudienceData.organizationPersona) && (
                      <BasicButton
                        type="button"
                        theme="dark"
                        loading={loading}
                        disabled={loading}
                        image={{
                          src: '/icons/Playlist.svg',
                          height: 14,
                          width: 14,
                        }}
                        text={
                          successfulAudienceSaved
                            ? 'Audience Saved!'
                            : 'Save Persona'
                        }
                        onClick={() => props.handleSubmit()}
                      />
                    )}
                  </div>
                </div>
                {/* header ends here */}

                <div className={styles['input-container-flex']}>
                  {/* start of left side */}
                  <div className={styles['left-side']}>
                    {/* start of left-top */}
                    <div className={styles['input-left-top']}>
                      <div className={styles['column2']}>
                        <h3>
                          <u>Audience Name</u>
                        </h3>
                        <BasicInput
                          id="audience-persona-input"
                          disabled={false}
                          label={
                            <p>This will be used just for saving purposes.</p>
                          }
                          placeholder="Hard Working Marketers"
                          setValue={props.handleChange('audience')}
                          touched={props.touched.audience ? true : false}
                          onBlur={props.handleBlur}
                          errors={props.errors.audience as string}
                          value={props.values.audience}
                        />
                        <p>What brand does this audience belong to?</p>
                        <Select
                          onChange={(newValue) => setValue(newValue)}
                          options={optionlist}
                          inputValue={''}
                          value={value}
                        />
                        {brandError && (
                          <p>
                            <span style={{ color: '#FF0000' }}>
                              Please Select a Brand
                            </span>
                          </p>
                        )}
                      </div>

                      <div className={styles['relative']}>
                        <div
                          className={styles['selectedImage']}
                          onClick={() => setShowIconPicker(!showIconPicker)}
                        >
                          <Image
                            src={selectedIcon ? selectedIcon : photo}
                            alt={''}
                            height={80}
                            width={80}
                            className={styles['image']}
                          />
                          {/* <div className={styles['change-icon-bubble']}>Change Icon</div> */}
                        </div>
                        <div>
                          <BasicButton
                            type="button"
                            theme="white"
                            loading={loading}
                            disabled={loading}
                            text={'Edit Photo'}
                            onClick={() => setShowIconPicker(!showIconPicker)}
                            extraSmall={true}
                          />
                        </div>
                        {showIconPicker && (
                          <div className={styles['icon-picker']}>
                            {imagePaths.map((icon) => (
                              <div key={icon} onClick={() => IconClick(icon)}>
                                <Image
                                  src={icon}
                                  alt={''}
                                  height={50}
                                  width={50}
                                />
                              </div>
                            ))}
                            <label
                              htmlFor="fileUpload"
                              className={styles['custom-file-upload']}
                            >
                              <Image
                                src="/icons/Add_Icon.svg" // or any icon that indicates file upload
                                alt="Upload icon"
                                height={50}
                                width={50}
                              />
                              <input
                                type="file"
                                id="fileUpload"
                                onChange={handleFileUpload}
                                className={styles['hidden']}
                              />
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* end of left-top */}
                    <div className={styles['right-side']}>
                      <h3> Demographics</h3>
                    </div>
                    {/* start of the left-bottom */}
                    <div className={styles['input-left-bottom']}>
                      <div className={styles['input-container']}>
                        <BasicButtonSelectionInput
                          isMultipleSelection
                          allowUserInput
                          id="gender"
                          label={
                            <div>
                              <p>What is their gender?</p>
                            </div>
                          }
                          defaultOptions={genderOptions}
                          // defaultOptionIcons={defaultSocialIcon}
                          value={props.values.gender}
                          disabled={loading}
                          errors={props.errors.gender as string}
                          touched={props.touched.gender ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                      <div className={styles['input-container']}>
                        <BasicButtonSelectionInput
                          isMultipleSelection
                          allowUserInput
                          id="age"
                          label={
                            <div>
                              <p>What is their age range?</p>
                            </div>
                          }
                          defaultOptions={ageOptions}
                          // defaultOptionIcons={defaultSocialIcon}
                          value={props.values.age}
                          disabled={loading}
                          errors={props.errors.age as string}
                          touched={props.touched.age ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                      <div className={styles['input-container']}>
                        <BasicButtonSelectionInput
                          isMultipleSelection
                          allowUserInput
                          id="occupation"
                          label={
                            <div>
                              <p>What are their attributes?</p>
                            </div>
                          }
                          defaultOptions={occupationOptions}
                          // defaultOptionIcons={defaultSocialIcon}
                          value={props.values.occupation}
                          disabled={loading}
                          errors={props.errors.occupation as string}
                          touched={props.touched.occupation ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                      <div className={styles['input-container']}>
                        <BasicButtonSelectionInput
                          isMultipleSelection
                          allowUserInput
                          id="location"
                          label={
                            <div>
                              <p>Where do they live?</p>
                            </div>
                          }
                          defaultOptions={locationOptions}
                          // defaultOptionIcons={defaultSocialIcon}
                          value={props.values.location}
                          disabled={loading}
                          errors={props.errors.location as string}
                          touched={props.touched.location ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>
                    {/* end of left-bottom */}
                  </div>
                  {/* end of left */}
                  <div className={styles['middle-side']}></div>
                  {/* start of right */}
                  <div className={styles['column']}>
                    <h3
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0px',
                        marginTop: '5px',
                      }}
                    >
                      <u>Psychographics</u>
                      <Tooltip tooltipText="Psychographics are the attitudes, interests, and values of your audience." />
                    </h3>
                    <div className={styles['input-container']}>
                      <div
                        className={styles['header']}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px',
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          What are their problems?
                        </p>
                        <Tooltip tooltipText="Identify obstacles that may prevent your audience from engaging with your brand." />
                      </div>
                      <div>
                        <BoxedAutoResizeTextarea
                          id="audience-persona-input"
                          placeholder="Struggles with achieving desired outcomes efficiently."
                          value={props.values.painpoints}
                          setValue={props.handleChange('painpoints')}
                          disabled={loading}
                          errors={props.errors.painpoints as string}
                          touched={props.touched.painpoints ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>

                    <div className={styles['input-container']}>
                      <div
                        className={styles['header']}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px',
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>What are their goals?</p>
                        <Tooltip tooltipText="Clarify what your audience hopes to achieve—so your content aligns with their aspirations." />
                      </div>
                      <div>
                        <BoxedAutoResizeTextarea
                          id="audience-persona-input"
                          placeholder="Wants to improve efficiency and productivity."
                          value={props.values.goals ?? ''}
                          setValue={props.handleChange('goals')}
                          disabled={loading}
                          errors={props.errors.goals as string}
                          touched={props.touched.goals ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>

                    <div className={styles['input-container']}>
                      <div
                        className={styles['header']}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px',
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          What are their triggers?
                        </p>
                        <Tooltip tooltipText="Spot the moments or events that drive your audience to take action." />
                      </div>
                      <div>
                        <BoxedAutoResizeTextarea
                          id="audience-persona-input"
                          placeholder="Motivated by time-sensitive opportunities or deadlines."
                          value={props.values.triggers ?? ''}
                          setValue={props.handleChange('triggers')}
                          disabled={loading}
                          errors={props.errors.triggers as string}
                          touched={props.touched.triggers ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>

                    <div className={styles['input-container']}>
                      <div
                        className={styles['header']}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0px',
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          What are their barriers?
                        </p>
                        <Tooltip tooltipText="Identify obstacles that may prevent your audience from engaging with your brand." />
                      </div>
                      <div>
                        <BoxedAutoResizeTextarea
                          id="audience-persona-input"
                          placeholder="Constrained by time or resource availability."
                          value={props.values.barriers ?? ''}
                          setValue={props.handleChange('barriers')}
                          disabled={loading}
                          errors={props.errors.barriers as string}
                          touched={props.touched.barriers ? true : false}
                          onBlur={props.handleBlur}
                          extraSmall={true}
                        />
                      </div>
                    </div>
                  </div>
                  {/* end of right */}
                </div>
              </div>
            </>
          );
        }}
      </Formik>
    </>
  );
};
